'use strict';
window.trackTimings = window.trackTimings || [];
window.addEventListener('load', function () {
    var INPUT_TIMING_PREFIX = 'filled_out_input_field';
    function trackTiming(inputName, timing) {
        if (timing < 0) {
            return;
        }
        window.trackTimings.push({
            variable: INPUT_TIMING_PREFIX,
            opt_label: inputName,
            time: timing
        });
    }

    $('select, input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="hidden"]), textarea').on('focus', function () {
        $(this).attr('focusedAt', Date.now());
    }).on('blur', function () {
        var $this = $(this);
        if ($this.val()) {
            var timing = Date.now() - $this.attr('focusedAt');
            trackTiming($this.attr('name'), timing);
        }
    });
});
